(() => {
	'use strict';
	angular.module('bmsApp.instantMessaging')
		.factory('InstantMessagingRepository', InstantMessagingRepository);

	InstantMessagingRepository.$inject = [
		'CRUDSvc',
	];

	function InstantMessagingRepository(CRUDSvc) {
		function conversations(params) {
			return CRUDSvc.get('api/instant-messaging/conversations', params);
		}

		function sendMessage(params) {
			return CRUDSvc.post('api/instant-messaging/send-message', params);
		}

		function markMessagesRead(params) {
			return CRUDSvc.post('api/instant-messaging/mark-messages-read', params);
		}

		function loadMoreMessages(params) {
			return CRUDSvc.get('api/instant-messaging/messages', params);
		}

		return {
			conversations: conversations,
			sendMessage: sendMessage,
			markMessagesRead: markMessagesRead,
			loadMoreMessages: loadMoreMessages,
		}
	}
})();
